import { useTranslation } from 'react-i18next';
import { categories } from '@/data/categories';

export default function CategoryGrid() {
  const { t } = useTranslation();

  return (
    <section id="categories" className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
      <div className="text-center">
        <h2 className="text-2xl md:text-4xl font-bold text-foreground-950">{t('categories_title')}</h2>
        <p className="mx-auto mt-3 max-w-2xl text-sm md:text-base text-foreground-600">
          {t('categories_subtitle')}
        </p>
      </div>

      <div className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
        {categories.map((cat) => (
          <a
            key={cat.key}
            href={cat.url}
            target="_blank"
            rel="noopener nofollow"
            className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-transform hover:-translate-y-1 cursor-pointer"
          >
            <div className="relative h-40 w-full overflow-hidden sm:h-44">
              <img
                src={cat.image}
                alt={t(`category_${cat.key}`)}
                title={`${t(`category_${cat.key}`)} — USFans Spreadsheet`}
                className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
              />
            </div>
            <div className="flex items-center justify-between gap-2 p-3 md:p-4">
              <span className="text-sm font-semibold text-foreground-900">{t(`category_${cat.key}`)}</span>
              <span className="flex h-7 w-7 items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className="ri-arrow-right-up-line" aria-hidden="true"></i>
              </span>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}